module.exports = __webpack_public_path__ + "static/DevOps-1bbfd41216d415d0ef630e9805667ad3.mp4";